export enum PresentationTypeEnum {
  DateTime = 'date-time',
  TimeDate = 'time-date',
  Date = 'date',
  Time = 'time',
  Month = 'month',
  Year = 'year',
  MonthYear = 'month-year',
}
